import { Component, HostListener, inject, Input, OnDestroy, OnInit } from '@angular/core'
import { Store } from '@ngxs/store'
import { Router } from '@angular/router'
import { IUser, Logout, ReferralType, UserAccountState } from '@mg-platform/users/users-data-access'
import { Observable } from 'rxjs'
import { MobileMaxWidth } from '@mg-platform/core/core-util'
import { IHeaderRouteInfo } from './main-header.interface'
import { StateResetAll } from 'ngxs-reset-plugin'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { MatDialog } from '@angular/material/dialog'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { SidemenuBottomSheetComponent } from '../sidemenu-bottom-sheet/sidemenu-bottom-sheet.component'

@UntilDestroy()
@Component({
  selector: 'mg-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  standalone: false
})
export class MainHeaderComponent implements OnInit, OnDestroy {
  @Input() forAdmin = false
  @Input() mainMenuRoutes: IHeaderRouteInfo[]
  @Input() profileMenuRoutes: IHeaderRouteInfo[]
  currentUser$: Observable<IUser> = inject(Store).select(UserAccountState.currentUser)
  currentUser: IUser
  openedBottomSheetType?: 'main' | 'profile'

  referralType = ReferralType

  constructor(
    private store: Store,
    private router: Router,
    private dialogService: MatDialog,
    private bottomSheetService: MatBottomSheet
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (!this.forAdmin && event.target.innerWidth > MobileMaxWidth) {
      this.dialogService.closeAll()
      this.bottomSheetService.dismiss()
    }
  }

  ngOnInit(): void {
    this.currentUser$.pipe(untilDestroyed(this)).subscribe((res) => {
      this.currentUser = res
    })
  }

  ngOnDestroy(): void {
    this.bottomSheetService.dismiss()
  }

  logout() {
    this.store.dispatch(new Logout()).subscribe(() => {
      this.router.navigateByUrl('/login')
      this.store.dispatch(new StateResetAll())
    })
  }

  openSideMenuBottomSheet(type: 'main' | 'profile') {
    this.openedBottomSheetType = type
    this.bottomSheetService
      .open(SidemenuBottomSheetComponent, {
        data: {
          items: type === 'main' ? this.mainMenuRoutes : this.profileMenuRoutes,
          type
        },
        autoFocus: false,
        backdropClass: 'bg-transparent'
      })
      .afterDismissed()
      .subscribe(() => {
        this.openedBottomSheetType = undefined
      })
  }
}
